import { render, staticRenderFns } from "./GuestOrderPanel.vue?vue&type=template&id=1668b398"
import script from "./GuestOrderPanel.vue?vue&type=script&lang=js"
export * from "./GuestOrderPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports